import gql from 'gql-tag'

export const BASE_DEVICE_FRAGMENT = gql`
  fragment BaseDevice on Device {
    resourceType
    id
    type {
      coding {
        system
        code
        display
      }
    }
  }
`
